import { createRequiredContext } from '../../../libs/context'

export type ModalContextType = {
  onClose: () => void
}

const [useModalContext, Provider] =
  createRequiredContext<ModalContextType>('Modal')

export { Provider, useModalContext }
